export default function() {
  return process.env.REACT_APP_ENV || 'development';
}